module.exports = __webpack_public_path__ + "img/2009-11_der-spiegel.4392dc11.png";